import { BaseError } from "./base-error";

export class OopsError extends BaseError {
  constructor(errorId: string, msg: string) {
    super(errorId, "Ooops! Something weng wrong." + (msg ?  " Details: " : "") + msg);
  }
}